import { SecondaryButton } from '@/components/Shared/Buttons';
import {
  useActiveProfile,
  useTokenState
} from '@/store/localStorage/useTokenState';
import { markAllNotificationsRead } from '@/store/notifications/operations';
import { selectNotificationsTotal } from '@/store/notifications/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { ResetButtonArea } from './styled';

export function ResetAllNotifications() {
  const { activeProfileId } = useActiveProfile();
  const [token] = useTokenState();
  const notificationsTotal = useSelector(selectNotificationsTotal);
  const dispatch = useDispatch();

  if (notificationsTotal > 0) {
    return (
      <ResetButtonArea>
        <SecondaryButton
          onClick={() =>
            dispatch(markAllNotificationsRead({ token, activeProfileId }))
          }
          title="Отметить все уведомления прочитанными"
        >
          сбросить уведомления
        </SecondaryButton>
      </ResetButtonArea>
    );
  } else {
    return null;
  }
}
